import React, { useEffect, useState, useRef } from 'react';
import {
  ScheduleComponent,
  TreeViewArgs,
  ResourcesDirective,
  ResourceDirective,
  ViewsDirective,
  ViewDirective,
  ResourceDetails,
  Inject,
  TimelineViews,
  Resize,
  TimelineMonth
} from '@syncfusion/ej2-react-schedule';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import styles from './global-calendar.module.scss';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import { PUBLIC_PATH, APP_ROUTES } from '../../../../../shared/config/routes-config';
import { flattenDeep } from 'lodash';
import { RouteConfig } from '../../../../../shared/interfaces/routes-config.interface';
import { BlockedDatesUiModel } from '../../../../../shared/ui-models/blocked-dates.ui-model';
import { getAllReservations } from '../../../../../ReservationModule/shared/services/data.service';
import { isErrorInfo, ErrorInfo } from '../../../../../shared/interfaces/error-info.interface';
import { ReservationStatus } from '../../../../../shared/enums/reservation-status';
import { getAllUnitTypes } from '../../../../../shared/services/data/unit-type.data';
import { getModuleName } from '../../../../shared/services/dashboard.service';
import Select, { ValueType } from 'react-select';
import type { StylesConfig } from 'react-select';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import {
  ReservationListUiModel,
  ReservationUiModel
} from '../../../../../shared/ui-models/reservation.ui-model';
import { UnitTypeGroupUiModel } from '../../../../../shared/ui-models/unit-type-group.ui-model';
import { getAllUnitTypeGroups } from '../../../../../shared/services/data/lookups.data';
import _ from 'lodash';
import { FormElementData } from '../../../../../shared/interfaces/form-element-data.interface';
import { getAllBlockingDates } from '../../../../shared/services/data.service';
import { connect } from 'react-redux';
import { RootState } from '../../../../../shared/redux/reducers';

export const projectSelectStyles: StylesConfig<{ value: string; label: string }, true> = {
  valueContainer: (base) => ({ ...base, maxHeight: 40, overflowY: 'auto', padding: '2px 8px' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base) => ({ ...base, minHeight: 38 })
};

const colors: string[] = [
  '#FF6633',
  '#FFB399',
  '#FF33FF',
  '#FFFF99',
  '#00B3E6',
  '#E6B333',
  '#3366E6',
  '#999966',
  '#006300',
  '#B34D4D',
  '#80B300',
  '#809900',
  '#E6B3B3',
  '#6680B3',
  '#66991A',
  '#FF99E6',
  '#94be00',
  '#FF1A66',
  '#E6331A',
  '#33FFCC',
  '#66994D',
  '#B366CC',
  '#4D8000',
  '#B33300',
  '#CC80CC',
  '#66664D',
  '#991AFF',
  '#E666FF',
  '#4DB3FF',
  '#1AB399',
  '#E666B3',
  '#33991A',
  '#CC9999',
  '#B3B31A',
  '#00E680',
  '#4D8066',
  '#809980',
  '#E6FF80',
  '#1AFF33',
  '#999933',
  '#FF3380',
  '#CCCC00',
  '#66E64D',
  '#4D80CC',
  '#9900B3',
  '#E64D66',
  '#4DB380',
  '#FF4D4D',
  '#99E6E6',
  '#6666FF'
];
export const GlobalCalendarComponent = ({ userId }: any) => {
  const [events, setEvents] = useState<Record<string, any>[]>();
  const [unitsData, setUnitsData] = useState<any[]>();
  const [sortedUnitsData, setSortedUnitsData] = useState<any[]>();

  const [uniqKey, setUniqKey] = useState(Date.now);
  const [unitType, setUnitType] = useState<{ value: ''; label: '' }>({ value: '', label: '' });

  const [unitTypeOptions, setUnitTypeOptions] = useState<
    {
      value: string;
      label: string;
      propertyId: string;
      userId: string;
      areaId: string;
    }[]
  >([]);

  const [unitTypeGroupsList, setUnitTypeGroupsList] = useState<UnitTypeGroupUiModel[]>([]);

  const scheduleRef = useRef(null);

  const [area, setArea] = useState<{ value: string; label: string }>({ value: '', label: '' });
  const [project, setProject] = useState<{ value: string; label: string }[]>([]);
  const [unitTypeSearch, setUnitTypeSearch] = useState<FormElementData<string>>({
    value: '',
    isValid: true
  });
  const [unitTypeGroup, setUnitTypeGroup] = useState<{ value: string; label: string }>({
    value: '',
    label: ''
  });

  const [currentDataSelected, setCurrentDataSelected] = useState<Date>(new Date());
  const [unitTypesList, setUnitTypesList] = useState<UnitTypeUiModel[]>();
  const [lazyLoading, setLazyLoading] = useState<boolean>(false);
  const [initialUnitList, setInitialUnitList] = useState<UnitTypeUiModel[]>([]);
  const [groupOptions, setGroupOptions] = useState<
    {
      value: string;
      label: string;
      roomId: [];
      propertyId: string;
      areaId: string;
      userId: string;
    }[]
  >([]);
  const [initialGroupIdOptions, setInitialGroupIdOptions] = useState<
    {
      value: string;
      label: string;
      roomId: [];
      propertyId: string;
      areaId: string;
      userId: string;
    }[]
  >([]);
  const getReservations = (currentDate: Date, filteredUnitTypes?: UnitTypeUiModel[]) => {
    getAllReservations(
      {
        statusQuery: [
          ReservationStatus.CHECKED_IN,
          ReservationStatus.CHECKED_OUT,
          ReservationStatus.CONFIRMATION_PENDING,
          ReservationStatus.IN_HOUSE,
          ReservationStatus.CHECKED_IN_STARTED,
          ReservationStatus.PENDING_CHECK_IN
        ],
        $or: [
          {
            checkInDate: {
              $gte: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime(),
              $lte: moment(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0))
                .add(1, 'days')
                .toDate()
                .getTime()
            }
          },
          {
            checkOutDate: {
              $gte: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime(),
              $lte: moment(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0))
                .add(1, 'days')
                .toDate()
                .getTime()
            }
          },
          {
            $and: [
              {
                checkInDate: {
                  $lte: moment(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0))
                    .add(1, 'days')
                    .toDate()
                    .getTime()
                }
              },
              {
                checkOutDate: {
                  $gt: new Date(currentDate.getFullYear(), currentDate.getMonth(), +1, 0).getTime()
                }
              }
            ]
          }
        ]
      },
      1,
      0
    ).then((response: ReservationListUiModel | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setLazyLoading(false);
        if (response && response?.reservationList?.length > 0) {
          // Get valid unit IDs from filtered unit types
          const unitTypesToFilter = filteredUnitTypes || unitTypesList || initialUnitList;
          const validUnitIds = new Set(
            flattenDeep(
              unitTypesToFilter?.map((unitType) =>
                unitType.units ? unitType.units.map((unit) => unit.unitId) : []
              ) || []
            )
          );

          // Filter reservations to only include those matching the unit types
          const filteredReservations = response.reservationList.filter((reservation) =>
            validUnitIds.has(reservation.roomId)
          );
          getBlockingDates({ query: { isCancelled: false } }, filteredReservations);
        }
      }
    });
  };
  const getBlockingDates = (query: {}, reservations: ReservationUiModel[]) => {
    getAllBlockingDates(query).then((response: BlockedDatesUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        if (response && response.length > 0) {
          setEvents([
            ...reservations.map((item, index) => ({
              Id: index,
              Subject:
                item.status === ReservationStatus.PENDING_CHECK_IN
                  ? '[PENDING] ' + item.primaryGuestName
                  : item.primaryGuestName,
              StartTime: moment(item.checkInDate).format('MM/DD/YYYY'),
              EndTime: moment(item.checkOutDate).format('MM/DD/YYYY'),
              IsAllDay: true,
              IsBlock: true,
              id: item.roomId,
              reservationId: item.id,
              blockedDate: false
            })),
            ...response.map((item, index) => ({
              Id: index,
              Subject: `BLOCKED (${item.description})`,
              StartTime: moment(item.fromDate).format('MM/DD/YYYY'),
              EndTime: moment(item.toDate).format('MM/DD/YYYY'),
              IsAllDay: true,
              IsBlock: true,
              id: item.roomId,
              blockedDateId: item.id,
              blockedDate: true
            }))
          ]);
        }
      }
    });
  };

  const filterDataWithoutDuplicate = (
    data: UnitTypeUiModel[],
    unitGroups: UnitTypeGroupUiModel[]
  ) => {
    const groupId: {
      value: string;
      label: string;
      areaId: string;
      propertyId: string;
      userId: string;
      roomId: [];
    }[] = [];

    data?.map((unit) => {
      if (unit?.unitTypeGroupId !== undefined) {
        groupId.push({
          value: unit?.unitTypeGroupId,
          label: unitGroups?.find((unitGroup) => unitGroup?.id === unit?.unitTypeGroupId)?.name,
          roomId: unit?.units,
          areaId: unit?.areaId,
          propertyId: unit?.propertyId,
          userId: unit?.landlordId
        });
      }
    });

    if (groupId.length > 0) {
      setGroupOptions(_.uniqBy(groupId, 'value'));
      setInitialGroupIdOptions(_.uniqBy(groupId, 'value'));
    }
  };

  useEffect(() => {
    getAllUnitTypes('DASHBOARD_MODULE').then((res: UnitTypeUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(res)) {
        const response = res?.filter(
          (unit: any) => unit.partnerId === userId || unit.landlordId === userId
        );
        setUnitsData(
          flattenDeep(
            response && response?.length > 0
              ? response?.map((unitType: any) =>
                  unitType.units
                    ? unitType.units.map((unit: any) => ({
                        id: unit.unitId,
                        unitTypeId: unitType.id,
                        name: unit.shortName,
                        color: colors[Math.floor(Math.random() * 50)],
                        description:
                          unitType.name +
                          ' ' +
                          (unit.roomNumber && unit.roomNumber !== 'undefined'
                            ? ' #' + unit.roomNumber
                            : ''),
                        coverImage: unitType.coverImage
                      }))
                    : []
                )
              : []
          )
        );
        setInitialUnitList(response);

        const tempUnitTypeList = response;
        setUnitsData(
          flattenDeep(
            tempUnitTypeList
              ? tempUnitTypeList.map((unitType) =>
                  unitType.units
                    ? unitType.units.map((unit) => ({
                        id: unit.unitId,
                        unitTypeId: unitType.id,
                        name: unit.shortName,
                        color: colors[Math.floor(Math.random() * 50)],
                        description:
                          unitType.name +
                          ' ' +
                          (unit.roomNumber && unit.roomNumber !== 'undefined'
                            ? ' #' + unit.roomNumber
                            : ''),
                        coverImage: unitType.coverImage
                      }))
                    : []
                )
              : []
          )
        );
        setUnitTypesList(tempUnitTypeList);
        setUnitTypeOptions(
          response?.map((unitType: any) => ({
            value: unitType.id,
            label: unitType.name || ''
          }))
        );
        getReservations(new Date(), tempUnitTypeList);
      }
    });

    getAllUnitTypeGroups(getModuleName()).then((response: UnitTypeGroupUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setUnitTypeGroupsList(response);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (unitTypeGroupsList.length > 0 && initialUnitList.length > 0) {
      filterDataWithoutDuplicate(initialUnitList, unitTypeGroupsList);
    }
  }, [unitTypeGroupsList, initialUnitList]);

  const getUnitTypeName = (value: ResourceDetails | TreeViewArgs): string => {
    return (value as ResourceDetails).resourceData[(value as any).resource.textField] as string;
  };
  const getUnitTypeDescription = (value: ResourceDetails | TreeViewArgs): string => {
    return (value as ResourceDetails).resourceData.description as string;
  };
  const getUnitTypeImage = (value: ResourceDetails): string => {
    return (value as ResourceDetails).resourceData.coverImage as string;
  };

  function calculateMonthlyDuration(
    startTime: string,
    endTime: string,
    monthStartDate: Date,
    monthEndDate: Date
  ): number {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    const effectiveStart = startDate < monthStartDate ? monthStartDate : startDate;
    const effectiveEnd = endDate > monthEndDate ? monthEndDate : endDate;

    const duration =
      Math.ceil((effectiveEnd.getTime() - effectiveStart.getTime()) / (1000 * 3600 * 24)) + 1;
    return duration > 0 ? duration : 0;
  }

  useEffect(() => {
    if (unitsData && events && currentDataSelected) {
      const selectedYear = currentDataSelected.getFullYear();
      const selectedMonth = currentDataSelected.getMonth();

      const monthStartDate = new Date(selectedYear, selectedMonth, 1);
      const monthEndDate = new Date(selectedYear, selectedMonth + 1, 0);

      const roomDurationMap: { [key: string]: number } = {};
      events.forEach((event) => {
        const duration = calculateMonthlyDuration(
          event.StartTime,
          event.EndTime,
          monthStartDate,
          monthEndDate
        );
        if (duration > 0) {
          // Only count if there is an overlap
          if (roomDurationMap[event.id]) {
            roomDurationMap[event.id] += duration;
          } else {
            roomDurationMap[event.id] = duration;
          }
        }
      });

      const sortedUnits = [...unitsData].sort((a, b) => {
        const durationA = roomDurationMap[a.id] || 0;
        const durationB = roomDurationMap[b.id] || 0;
        return durationA - durationB;
      });

      setSortedUnitsData(sortedUnits);
      setUniqKey(Date.now());
    }
  }, [unitsData, events, currentDataSelected]);

  const handleSearchClick = () => {
    const tempUnitTypeList = initialUnitList?.filter(
      (unit) =>
        unit.areaId?.includes(area.value !== '' ? area.value : unit.areaId) &&
        unit.unitTypeGroupId?.includes(
          unitTypeGroup.value !== '' ? unitTypeGroup.value : unit.unitTypeGroupId
        ) &&
        (project.length === 0 || project.some((p) => unit.propertyId?.includes(p.value))) &&
        (unitType.value === '' ||
          unit?.units?.reduce((acc, room) => {
            if (room?.unitId?.includes(unitType.value !== '' ? unitType.value : unit?.id)) {
              return true;
            } else {
              return acc || false;
            }
          }, false)) &&
        (unitTypeSearch.value === '' ||
          unit.name?.toLowerCase().includes(unitTypeSearch.value.toLowerCase()) ||
          unit.area?.toLowerCase().includes(unitTypeSearch.value.toLowerCase()) ||
          unit.propertyName?.toLowerCase().includes(unitTypeSearch.value.toLowerCase()) ||
          unit?.units?.reduce((acc, room) => {
            if (
              room.shortName?.toLowerCase().includes(unitTypeSearch.value) ||
              room.roomNumber?.toLowerCase().includes(unitTypeSearch.value) ||
              room.unitId?.toLowerCase().includes(unitTypeSearch.value)
            ) {
              return true;
            } else {
              return acc;
            }
          }, false))
    );

    setUnitsData(
      flattenDeep(
        tempUnitTypeList
          ? tempUnitTypeList.map((unitType) =>
              unitType.units
                ? unitType.units.map((unit) => ({
                    id: unit.unitId,
                    unitTypeId: unitType.id,
                    name: unit.shortName,
                    color: colors[Math.floor(Math.random() * 50)],
                    description:
                      unitType.name +
                      ' ' +
                      (unit.roomNumber && unit.roomNumber !== 'undefined'
                        ? ' #' + unit.roomNumber
                        : ''),
                    coverImage: unitType.coverImage
                  }))
                : []
            )
          : []
      )
    );

    setUnitTypesList(tempUnitTypeList);
    // Refresh reservations with filtered unit types
    getReservations(currentDataSelected, tempUnitTypeList);
    setTimeout(() => {
      if (scheduleRef && scheduleRef.current)
        // scheduleRef.current.refreshProperties();
        scheduleRef.current.refreshTemplates();
    });
  };

  return (
    <div className={styles['global-calendar']}>
      <div className={styles['global-calendar__reservation-item']}>
        <div className={styles['global-calendar__reservation-item__form-field']}>
          <div className={styles['global-calendar__reservation-item__form-field__label']}>
            Unit Name
          </div>
          <Select
            value={{ value: unitType.value, label: unitType.label }}
            options={unitTypeOptions?.map((room) => ({
              value: room.value,
              label: room.label
            }))}
            className={styles['global-calendar__reservation-item__form-field__select']}
            onChange={(value: ValueType<{ value: string | undefined; label: string }, false>) => {
              setUnitType(
                value ? { value: value.value || '', label: value.label } : { value: '', label: '' }
              );
              setGroupOptions(
                initialGroupIdOptions?.filter((unit) =>
                  unit?.roomId?.reduce((acc, room) => {
                    if (room?.unitId?.includes(value?.value)) {
                      return true;
                    } else {
                      return acc || false;
                    }
                  }, false)
                )
              );
              setUnitTypeGroup({ value: '', label: '' });
            }}
          />
        </div>
        <div className={styles['global-calendar__reservation-item__form-field']}>
          <div className={styles['global-calendar__reservation-item__form-field__label']}>
            Unit type
          </div>
          <Select
            value={{ value: unitTypeGroup.value, label: unitTypeGroup.label }}
            className={styles['global-calendar__reservation-item__form-field__select']}
            options={groupOptions.map((group) => ({
              value: group.value,
              label: group.label
            }))}
            onChange={(value: ValueType<{ value: string | undefined; label: string }, false>) => {
              setUnitTypeGroup(
                value ? { value: value.value || '', label: value.label } : { value: '', label: '' }
              );
            }}
          />
        </div>

        <div className={styles['global-calendar__reservation-item__actions']}>
          <Button
            className={styles['global-calendar__reservation-item__search-input__btn']}
            onClick={handleSearchClick}
            tracking={{ event: 'search_performed', scope: 'unittypes' }}
            size={ButtonSize.medium}
          >
            <SearchIcon />
          </Button>
          <Button
            className={styles['global-calendar__reservation-item__search-input__btn']}
            onClick={() => {
              filterDataWithoutDuplicate(initialUnitList, unitTypeGroupsList);
              setProject([]);
              setUnitType({ value: '', label: '' });
              setArea({ value: '', label: '' });
              setUnitTypeSearch({ value: '', isValid: true });
              setUnitTypeGroup({ value: '', label: '' });
              setUnitTypesList(initialUnitList);
              setUnitsData(
                flattenDeep(
                  initialUnitList
                    ? initialUnitList.map((unitType) =>
                        unitType.units
                          ? unitType.units.map((unit) => ({
                              id: unit.unitId,
                              unitTypeId: unitType.id,
                              name: unit.shortName,
                              color: colors[Math.floor(Math.random() * 50)],
                              description:
                                unitType.name +
                                ' ' +
                                (unit.roomNumber && unit.roomNumber !== 'undefined'
                                  ? ' #' + unit.roomNumber
                                  : ''),
                              coverImage: unitType.coverImage
                            }))
                          : []
                      )
                    : []
                )
              );
              getReservations(currentDataSelected, initialUnitList);
            }}
            tracking={{ event: 'search_cleared', scope: 'unittypes' }}
            size={ButtonSize.medium}
            type={ButtonType.gray}
          >
            clear
          </Button>
        </div>
      </div>
      {events && unitsData ? (
        <div className="schedule-control-section">
          <div className="col-lg-12 control-section">
            <div className="control-wrapper drag-sample-wrapper">
              <div className="schedule-container">
                {lazyLoading && (
                  <div className={styles['global-calendar__lazy-loader']}>
                    <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
                  </div>
                )}
                <ScheduleComponent
                  key={uniqKey} // Changing key forces re-render
                  ref={scheduleRef}
                  navigating={(event) => {
                    setLazyLoading(true);
                    if (
                      event &&
                      event.currentDate &&
                      event.previousDate &&
                      event.previousDate !== event.currentDate
                    ) {
                      setCurrentDataSelected(event.currentDate);
                      getReservations(event.currentDate, unitTypesList);
                    }
                  }}
                  // ref={(schedule) => (scheduleObj = schedule)}
                  cssClass="block-events"
                  width="100%"
                  height="1440px"
                  selectedDate={currentDataSelected}
                  currentView="TimelineMonth"
                  resourceHeaderTemplate={(props: any) => (
                    <div className="template-wrap">
                      <div className={styles['global-calendar__unit-type']}>
                        <img
                          className={styles['global-calendar__unit-type-image']}
                          src={
                            getUnitTypeImage(props) ||
                            `${PUBLIC_PATH}/assets/pngs/unit-type-default.png`
                          }
                          alt="unit-type"
                        />
                        <div className={styles['global-calendar__unit-type-description']}>
                          <Tooltip
                            title={
                              <span
                                className={
                                  styles['global-calendar__unit-type-description__tooltip']
                                }
                              >
                                {getUnitTypeName(props)}
                              </span>
                            }
                          >
                            <div className="employee-name">{getUnitTypeName(props)}</div>
                          </Tooltip>
                          <Tooltip
                            title={
                              <span
                                className={
                                  styles['global-calendar__unit-type-description__tooltip']
                                }
                              >
                                {getUnitTypeDescription(props)}
                              </span>
                            }
                          >
                            <div className="employee-designation">
                              {getUnitTypeDescription(props)}
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  )}
                  eventSettings={{
                    dataSource: events,
                    template: (props) => {
                      return (
                        <Tooltip
                          title={
                            <Typography style={{ fontSize: '1.5em' }}>
                              {props.reservationId || props.blockedDateId}
                            </Typography>
                          }
                        >
                          <div
                            style={{
                              backgroundColor: props.blockedDate
                                ? 'black'
                                : colors[Math.floor(Math.random() * 50)]
                            }}
                            className={styles['global-calendar__reservation']}
                          >
                            <div
                              onClick={() => {
                                const navigateTo = props.blockedDateId
                                  ? PUBLIC_PATH +
                                    (APP_ROUTES.BLOCK_DATES_MODULE.CHILDREN as RouteConfig).LIST
                                      .FULL_PATH
                                  : PUBLIC_PATH +
                                    (
                                      APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig
                                    ).EDIT.FULL_PATH.replace(':id', props.reservationId);
                                window.open(navigateTo, '_blank')?.focus();
                              }}
                            >
                              {props.Subject}
                              {'  '}
                            </div>
                            <button
                              className={styles['global-calendar__reservation__link']}
                              onClick={() => {
                                const navigateTo = props.blockedDateId
                                  ? PUBLIC_PATH +
                                    (APP_ROUTES.BLOCK_DATES_MODULE.CHILDREN as RouteConfig).LIST
                                      .FULL_PATH
                                  : PUBLIC_PATH +
                                    (
                                      APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig
                                    ).EDIT.FULL_PATH.replace(':id', props.reservationId);
                                window.open(navigateTo, '_blank')?.focus();
                              }}
                            >
                              #{props.reservationId || props.blockedDateId}
                            </button>
                          </div>
                        </Tooltip>
                      );
                    }
                  }}
                  group={{ enableCompactView: false, resources: ['Units'] }}
                >
                  <ResourcesDirective>
                    <ResourceDirective
                      field="id"
                      title="Room name"
                      name="Units"
                      allowMultiple={true}
                      dataSource={sortedUnitsData}
                      textField="name"
                      description="description"
                      idField="id"
                      colorField="color"
                    ></ResourceDirective>
                  </ResourcesDirective>
                  <ViewsDirective>
                    {/* <ViewDirective option="Day" /> */}
                    {/* <ViewDirective option="TimelineDay" /> */}
                    <ViewDirective option="TimelineMonth" />
                  </ViewsDirective>
                  <Inject services={[TimelineViews, TimelineMonth, Resize]} />
                </ScheduleComponent>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles['global-calendar__loader']}>
          <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
        </div>
      )}
    </div>
  );
};

export default connect(mapStateToProps)(GlobalCalendarComponent);

function mapStateToProps(state: RootState) {
  return {
    userId: state.auth.userId
  };
}
